import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../core/guards/auth.guard';
import {RecycleChartComponent} from './containers/weeesystem/recycle-chart/recycle-chart.component';
import {CountryVsWfChartComponent} from './containers/country/pom/country-vs-wf-chart/country-vs-wf-chart.component';
import {CompositionChartComponent} from './containers/country/pom/composition-chart/composition-chart.component';
import {EuropeanTrendChartComponent} from './containers/country/pom/european-trend-chart/european-trend-chart.component';
import {BenchmarkByYearChartComponent} from './containers/country/pom/benchmark-by-year-chart/benchmark-by-year-chart.component';
import {VctUpToComponent} from './containers/country/collected/vct-up-to/vct-up-to.component';
import {VctpFromComponent} from './containers/country/collected/vctp-from/vctp-from.component';
import {VctFromComponent} from './containers/country/collected/vct-from/vct-from.component';
import {VctpUpToComponent} from './containers/country/collected/vctp-up-to/vctp-up-to.component';
import {TrendByCountryChartComponent} from './containers/country/pom/trend-by-country-chart/trend-by-country-chart.component';
import {TrendByCountryComponent} from './containers/country/return/trend-by-country/trend-by-country.component';
import {ByYearChartComponent} from './containers/country/return/by-year-chart/by-year-chart.component';
import {CostBenchmarkComponent} from './containers/weeesystem/cost/cost-benchmark/cost-benchmark.component';
import {OperationsVsOverheadChartComponent} from './containers/weeesystem/cost/operations-vs-overhead-chart/operations-vs-overhead-chart.component';
import {AdditionalChartComponent} from './containers/weeesystem/cost/additional-chart/additional-chart.component';
import {ReturnRateBenchmarkComponent} from './containers/weeesystem/return-rate-benchmark/return-rate-benchmark.component';
import {DownloadKfDataComponent} from './components/download-kf-data/download-kf-data.component';
import {KfChartsGuard} from './guards/kf-charts.guard';

const routes: Routes = [
  {
    path: 'kfcharts', canActivate: [KfChartsGuard],
    children: [
      {
        path: 'country', children: [
          {
            path: 'putonmarket', children: [
              {path: 'europeantrend', component: EuropeanTrendChartComponent},
              {path: 'trendbycountry', component: TrendByCountryChartComponent},
              {path: 'benchmarkbyyear', component: BenchmarkByYearChartComponent},
              {path: 'countryvsweeeforum', component: CountryVsWfChartComponent},
              {path: 'composition', component: CompositionChartComponent},
            ]
          },
          {
            path: 'collected', children: [
              {path: 'europeantrend', component: EuropeanTrendChartComponent},
              {path: 'trendbycountry', component: TrendByCountryChartComponent},
              {path: 'benchmarkbyyear', component: BenchmarkByYearChartComponent},
              {path: 'countryvsweeeforum', component: CountryVsWfChartComponent},
              {path: 'composition', component: CompositionChartComponent},
              {path: 'vctupto2018', component: VctUpToComponent},
              {path: 'vctpupto2018', component: VctpUpToComponent},
              {path: 'vctfrom2019', component: VctFromComponent},
              {path: 'vctpfrom2019', component: VctpFromComponent},
            ]
          },
          {
            path: 'return', children: [
              {path: 'trendbycountry', component: TrendByCountryComponent},
              {path: 'byyear', component: ByYearChartComponent},
            ]
          },
          {path: 'download', component: DownloadKfDataComponent}
        ]
      },
      {
        path: 'weeesystem', canActivate: [AuthGuard],
        children: [
          {
            path: 'putonmarket',
            children: [
              {path: 'countryvsweeeforum', component: CountryVsWfChartComponent},
            ]
          },
          {
            path: 'collected',
            children: [
              {path: 'countryvsweeeforum', component: CountryVsWfChartComponent},
            ]
          },
          {
            path: 'recycle/collection', component: RecycleChartComponent, canActivate: [AuthGuard]
          },
          {
            path: 'returnrate/benchmark', component: ReturnRateBenchmarkComponent
          },
          {
            path: 'cost', canActivate: [AuthGuard],
            children: [
              {path: 'operational', component: CostBenchmarkComponent},
              {path: 'overheads', component: CostBenchmarkComponent},
              {path: 'operations-vs-overhead', component: OperationsVsOverheadChartComponent},
              {path: 'additional', component: AdditionalChartComponent},
            ]
          },
          {path: 'download', component: DownloadKfDataComponent}
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class KfChartsRoutingModule {
}
